import request from '@/units/request';
import store from '@/store';
import { defaultTenantId } from '@/units/config';

export default {
  // 活动列表（用于秒杀/拼团等入口页）
  // 说明：后端不存在 activity.activity/list 时，统一走 index
  list: (params) =>
    request({
      url: 'activity.activity/index',
      method: 'GET',
      params: {
        tenant_id:
          (store.getters && store.getters.tenant_id) || defaultTenantId || '',
        ...params,
      },
      custom: {
        showLoading: false,
        showError: false,
      },
    }),
  //活动详情
  activity: (id) =>
    request({
      url: 'activity.activity/detail',
      method: 'GET',
      params: {
        id: id,
      },
    }),
  //我的拼团列表
  myGroupon: (params) =>
    request({
      url: 'activity.groupon/myGroupons',
      method: 'GET',
      params,
    }),
  //拼团列表 
  getGrouponList: (params) =>
    request({
      url: 'activity.groupon/index',
      method: 'GET',
      params,
    }),
  //拼团详情
  grouponDetail: (id) =>
    request({
      url: 'activity.groupon/detail',
      method: 'GET',
      params: {
        id: id,
      },
    }),
  //签到日历
  signList: (params) =>
    request({
      url: 'activity.signin/index',
      method: 'GET',
      params,
    }),
  //签到
  signAdd: () =>
    request({
      url: 'activity.signin/signin',
      method: 'POST',
    }),
  //补签
  replenish: (data) =>
    request({
      url: 'activity.signin/replenish',
      method: 'POST',
      data,
    }),
};
